export default __webpack_public_path__ + "static/media/cert-cpttm.8a4007bb.jpg";